export default function generateWeeklyRanges(weekMasterData) {
    console.log("weekMasterData", weekMasterData)
    const weeklyRanges = {};
    weekMasterData.forEach((doc) => {
        const wno = doc.wk_no;
        if (!weeklyRanges[wno]) {
            weeklyRanges[wno] = { start: doc.dates, end: doc.dates };
        } else {
            if (doc.last_day === 1) {
                weeklyRanges[wno].end = doc.dates;
            }
        }
    });
    // console.log("weeklyRanges", weeklyRanges)
    return weeklyRanges;
}